__turbopack_context__.v({
  "comboboxSelected": "Combobox-module__r2iS9a__comboboxSelected",
  "comboboxSelectedLoading": "Combobox-module__r2iS9a__comboboxSelectedLoading",
  "comboboxSelected__pill": "Combobox-module__r2iS9a__comboboxSelected__pill",
});
